























































































import {Vue, Component, Ref} from "vue-property-decorator";
import VueApexCharts from 'vue-apexcharts';
import axios, {AxiosResponse} from 'axios';

type StatsResponse = {
  stats: Array<Category>
}

type Category = {
  id: number,
  date: string,
  name: string,
  regexp: string,
  count: number,
  unique: number,
  created_at: string,
}

type CategoriesModel = {
  headers: any
  data: Array<Category>
  loading: boolean
}


declare global {
  interface Date {
    addDays(days: number): Date

    addMillis(millis: number): Date
  }
}

Date.prototype.addDays = function (days: number): Date {
  this.setTime(this.getTime() + (days * 24 * 60 * 60 * 1000))
  return this
}

Date.prototype.addMillis = function (millis: number): Date {
  this.setTime(this.getTime() + (millis))
  return this
}

@Component({
  components: {
    'v-chart': VueApexCharts
  }
})
export default class PageCategories extends Vue {
  @Ref('site_snippet') siteSnippetElement: any
  @Ref('site_config') siteConfigElement: any
  @Ref('site_event') siteEventElement: any

  private chartOptions: any = {
    chart: {
      id: 'vuechart-example'
    },
    xaxis: {
      type: "datetime",
    }
  }
  series: any = []

  private event_id: string | null = null
  private date_menu: boolean = false
  private date: Array<string> = [
    (new Date()).addDays(-7).toISOString().substr(0, 10),
    (new Date()).toISOString().substr(0, 10),
  ]

  private categories: CategoriesModel = {
    headers: [
      {
        text: "Category",
        value: "name"
      },
      {
        text: "Views",
        value: "count"
      },
      {
        text: "Unique",
        value: "unique"
      },
      {
        text: "Actions",
        value: "actions",
        align: "right",
        sortable: false
      }
    ],
    data: [] as Array<Category>,
    loading: true,
  }

  mounted() {
    this.$store.dispatch('set_title', 'Categories')

    axios
        .get<Array<Category>>('/api/v1/pages/categories')
        .then(response => {
          this.categories.data = response.data
          this.update_stats()
        })

  }

  update_stats() {
    this.update_category_stats()
  }

  update_graph_stats() {
    while (this.series.length > 0) {
      this.series.pop();
    }

    let limit = 3;
    for (let category_ind in this.categories.data) {
      if (limit <= 0) {
        break;
      }
      let category = this.categories.data[category_ind];
      limit--;

      axios
          .get<StatsResponse>('/api/v1/pages/stat', {
            params: {
              from: new Date(this.date[0] + " ").toISOString(),
              to: new Date(this.date[1] + " ").addDays(1).addMillis(-1).toISOString(),
              tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
              by_date: true,
              no_pages: 1,
              category_id: category.id,
            }
          })
          .then(response => {
            response.data.stats.sort((a, b) => a.date.localeCompare(b.date));

            let elements: any = [];
            response.data.stats.forEach(function (stat: Category) {
              elements.push([
                (new Date(stat.date)).getTime(),
                stat.count
              ])
            })

            this.series.push({
              name: category.name,
              data: elements,
            })
          })
    }
  }

  update_category_stats() {
    let params: any = {
      from: new Date(this.date[0] + " ").toISOString(),
      to: new Date(this.date[1] + " ").addDays(1).addMillis(-1).toISOString(),
      tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
      no_pages: 1,
    }

    let req: Array<Promise<AxiosResponse<StatsResponse>>> = []

    this.categories.data.forEach((cat) => {
      params.category_id = cat.id
      req.push(axios
          .get<StatsResponse>('/api/v1/pages/stat', {
            params: params,
          }))
    })

    axios.all(req)
        .then(axios.spread((...responses) => {
          for (let ind in responses) {
            let cat = this.categories.data[ind];
            cat.count = responses[ind].data.stats[0].count
            cat.unique = responses[ind].data.stats[0].unique
            // this.categories.data[ind] = cat

            this.$set(this.categories.data, ind, cat)
          }

          this.categories.data.sort((a, b) => b.unique - a.unique)

          this.categories.loading = false;
          this.update_graph_stats()
        }))
  }

  date_picker_change() {
    this.date_menu = this.date.length === 1
    if (this.date.length != 2) return

    if (new Date(this.date[1]) < new Date(this.date[0])) {
      let d = this.date[1]
      this.date[1] = this.date[0]
      this.date[0] = d
    }

    this.update_stats()
  }


  get page_url(): string | (string | null)[] {
    return this.$route.query.url;
  }

  get site_id(): string | (string | null)[] {
    return this.$route.params.id;
  }

  view_category(category: Category) {
    this.$router.push({
      name: 'Category Pages',
      params: {
        category_id: category.id.toString(),
      }
    })
  }

  edit_category(category: Category) {
    this.name = category.name
    this.regexp = category.regexp
    this.id = category.id
    this.create_update_dialog = true
  }

  delete_category(category: Category) {
    this.categories.loading = true
    axios.delete<Category, any>('/api/v1/pages/categories/' + category.id).then(() => {
      this.categories.data = this.categories.data.filter(v => v.id != category.id)
      this.update_stats()
    })
  }

  private id: number = 0
  private name: String = ''
  private regexp: String = ''
  private create_update_dialog: boolean = false

  create_update_category() {
    this.categories.loading = true
    let url = '/api/v1/pages/categories'
    if (this.id > 0) url += '/' + this.id

    axios.post<Category>(url, {
      name: this.name,
      regexp: this.regexp,
    }).then(resp => {
      // only if new
      if (this.id == 0) this.categories.data.push(resp.data)
      else {
        let ind = this.categories.data.findIndex(el => el.id == this.id)
        if (ind!=-1) {
          let cat = this.categories.data[ind]
          cat.name = resp.data.name
          cat.regexp = resp.data.regexp
          this.$set(this.categories.data,ind,cat)
        }
      }
      this.update_stats()

      this.name = ''
      this.regexp = ''
      this.create_update_dialog = false
    })
  }
}
